module.exports = __webpack_public_path__ + "img/home1.e413626d.png";